import React, { useEffect, useState } from 'react';
import usePageTitle from '../../hooks/usePageTitle';
import EmptyState from '../../components/EmptyState';
import { getContractVariance } from '../../services/suiteApi';

function fmtMoney(n) {
  if (n == null || Number.isNaN(Number(n))) return '--';
  return `$${Number(n).toFixed(2)}`;
}

export default function ContractVariancePage() {
  usePageTitle('Contract variance');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const resp = await getContractVariance();
        if (cancelled) return;
        const v = resp?.data;
        setRows(Array.isArray(v) ? v : (v?.items || []));
      } catch (e) {
        if (!cancelled) setError(e?.response?.data?.message || e.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="dm-page">
      <header className="dm-page__header">
        <h1 className="dm-page__title">Contract variance</h1>
        <p className="dm-page__lede">
          Where what payers actually paid you drifts from what your contracts
          say they should have paid. Pursue the largest variances first.
        </p>
      </header>

      {error && <div className="dm-banner dm-banner--error">{error}</div>}

      <section className="dm-card">
        <div className="dm-card__title">Variance by payer / CPT</div>
        {loading ? (
          <div className="dm-card__empty">Loading...</div>
        ) : rows.length === 0 ? (
          <EmptyState
            title="No variance signals yet"
            body="Variance is computed once you have remits posted and payer-contract rates loaded."
            ctaLabel="Open payer roster"
            ctaTo="/payers"
          />
        ) : (
          <table className="dm-table">
            <thead>
              <tr>
                <th>Payer</th>
                <th>CPT</th>
                <th className="dm-table__num">Expected</th>
                <th className="dm-table__num">Actual</th>
                <th className="dm-table__num">Variance</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={`${r.payerCode || r.payerName || i}-${r.cpt || i}`}>
                  <td>{r.payerName || r.PayerName || r.payerCode || '--'}</td>
                  <td>{r.cpt || r.cptCode || '--'}</td>
                  <td className="dm-table__num">{fmtMoney(r.expectedAllowed || r.expected)}</td>
                  <td className="dm-table__num">{fmtMoney(r.actualPaid || r.actual)}</td>
                  <td className="dm-table__num">{fmtMoney(r.variance)}</td>
                  <td>{r.note || ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
    </div>
  );
}
